import { faFilter, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getAllProducts } from "../../features/products/productsSlice";
import { variant_type } from "../../utils/common";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import "./Shop_By_Category.css";
import FilterComponent from "../common-components/filter_component/FilterComponent";
import {
  getColours,
  getPolish,
  getSizes,
} from "../../features/colour/colourSlice";

import {
  getAllCategories,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";

const STEP = 4;

function Shop_By_Category() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");

  const categoryIdFromQuery = queryParams.get("category_id");
  const categoryNameFromQuery = queryParams.get("category");
  const dispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];

  const [visibleCounts, setVisibleCounts] = useState([]);

  // Scroll to a specific category section when "See Less" is clicked
  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };

  // const location = useLocation();

  const category_Id = location.state?.category_id;

  const productData = useSelector((state) => state.product.allProducts);
  const products = productData?.data || [];
  const categories = useSelector((state) => state.master.categories);
  const allsubcategory = useSelector((state) => state.master.subcategories);

  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = productData?.total_pages || 1;
  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  useEffect(() => {
    dispatch(getAllSubCategory({ category_id: selectedCategoryId }));
  }, [dispatch, selectedCategoryId]);

  const earringStyles = productData?.earringStyles || [];
  const necklaceStyles = productData?.necklaceStyles || [];
  const occasions = productData?.occasions || [];
  const designShapes = productData?.designShapes || [];

  const colours = useSelector((state) => state.colours.colour.data || []);
  const sizes = useSelector((state) => state.colours.size.data || []);
  const polishes = useSelector((state) => state.colours.polish.data || []);

  // const availableProducts = all_products.filter(
  //   (product) => Number(product?.stock || 0) > 0,
  // );

  const defaultFilters = {
    category: [],
    subCategory: [],
    colors: [],
    sizes: [],
    polish: [],
    earringStyle: [],
    necklaceStyle: [],
    occasions: [],
    designShapes: [],
    priceRange: 20000,
  };

  const [filters, setFilters] = useState(() => {
    const saved = sessionStorage.getItem("shopFilters");
    return saved ? JSON.parse(saved) : defaultFilters;
  });

  const updateFilter = (key, value) => {
    setFilters((prev) => {
      const updated = {
        ...prev,
        [key]: value,
      };

      return updated;
    });
  };

  useEffect(() => {
    sessionStorage.setItem("shopFilters", JSON.stringify(filters));
  }, [filters]);

  useEffect(() => {
    dispatch(getColours());
    dispatch(getSizes());
    dispatch(getPolish());
    dispatch(getAllCategories());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!categories.length) return;

  //   const firstCategory = category_Id || categories[0].id;

  //   setSelectedCategoryId(firstCategory);

  //   dispatch(getAllSubCategory({ category_id: firstCategory }));
  // }, [categories]);

  useEffect(() => {
    if (!categories.length) return;

    const selectedCategory = category_Id || categories[0].id;

    setSelectedCategoryId(selectedCategory);

    setFilters((prev) => ({
      ...prev,
      category: [selectedCategory],
      subCategory: [],
    }));

    dispatch(getAllSubCategory({ category_id: selectedCategory }));
  }, [categories, category_Id]);

  // useEffect(() => {
  //   if (!allsubcategory.length) return;

  //   setFilters((prev) => ({
  //     ...prev,
  //     category: [selectedCategoryId],
  //     subCategory: [allsubcategory[0].id],
  //   }));
  // }, [allsubcategory]);

  useEffect(() => {
    if (!allsubcategory.length || !selectedCategoryId) return;

    const firstSubCategory = allsubcategory[0];

    setSelectedSubCategoryId(firstSubCategory.id);

    setFilters((prev) => ({
      ...prev,
      category: [selectedCategoryId],
      subCategory: [firstSubCategory.id],
    }));
  }, [allsubcategory, selectedCategoryId]);

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);

  const [childList, setChildList] = useState([]);
  const [childStatus, setChildStatus] = useState(""); // noChild

  const handleCategoryClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
    setCurrentPage(1);
    setFilters((prev) => ({
      ...prev,
      category: [categoryId],
    }));
    setSelectedSubCategoryId(null);
  };

  // const handleSubCategoryClick = (subId) => {
  //   setSelectedSubCategoryId(subId);
  // };

  const handleSubCategoryClick = (subId) => {
    setSelectedSubCategoryId(subId);
    setCurrentPage(1);

    setFilters((prev) => ({
      ...prev,
      subCategory: [subId],
    }));
  };

  const [status, setStatus] = useState("");

  const [showFilter, setShowFilter] = useState(false);

  // SEARCH STATE
  const [searchTerm, setSearchTerm] = useState("");

  // SORT STATE
  const [sortType, setSortType] = useState("default");

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  // useEffect(() => {
  //   if (filters.category && filters.subCategory) {
  //     dispatch(
  //       getAllProducts({
  //         page: currentPage,
  //         per_page: itemsPerPage,
  //         category_id: filters.category.join(","),
  //         sub_category_id: filters.subCategory.join(","),
  //         // colour_id: filters.colors.join(","),
  //         polish_id: filters.polish.join(","),
  //         size_id: filters.sizes.join(","),
  //         earring_style: filters.earringStyle.join(","),
  //         necklace_style: filters.necklaceStyle.join(","),
  //         occasion: filters.occasions.join(","),
  //         design_shape: filters.designShapes.join(","),
  //         max_price: filters.priceRange,
  //         sortBy: sortType,
  //         name: searchTerm,
  //       }),
  //     );
  //   }
  // }, [dispatch, filters, searchTerm, sortType, currentPage]);

  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* new code for subcategories */}

          {/* <div className="mobile_filter_btn">
            <button onClick={handleShow} className="filter_btn">
              <FontAwesomeIcon icon={faFilter} style={{ color: "#840101" }} />{" "}
              <span>Filters</span>
            </button>

            <button onClick={handleShow} className="filter_btn ms-2">
              <FontAwesomeIcon icon={faSort} style={{ color: "#840101" }} />{" "}
              <span>Sort</span>
            </button>
          </div> */}
          {/* <div className="heading_holder">
            <h4 className="heading_text">Explore Collection</h4>
          </div> */}

          {/* <div className="cat_subcat_div">
            {status === "noCategory" ? (
              <p className="text-danger">No category available.</p>
            ) : (
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination, Navigation]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    486: { slidesPerView: 2.5, spaceBetween: 10 },
                    576: { slidesPerView: 3, spaceBetween: 10 },
                    768: { slidesPerView: 3, spaceBetween: 10 },
                    992: { slidesPerView: 4, spaceBetween: 10 },
                    1200: { slidesPerView: 5, spaceBetween: 10 },
                    1400: { slidesPerView: 6, spaceBetween: 10 },
                    1800: { slidesPerView: 7, spaceBetween: 10 },
                  }}
                >
                  {categories?.map((slide, index) => (
                    <SwiperSlide key={index} className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          eventKey={slide?.id}
                          className={
                            filters.category.includes(slide.id)
                              ? "activecategory"
                              : ""
                          }
                          onClick={() => {
                            handleCategoryClick(slide?.id);
                          }}
                        >
                          <Category_Subcategory_Card
                            className="product-image"
                            content={slide?.name}
                            image={
                              slide?.image
                                ? slide.image.startsWith("http")
                                  ? slide.image
                                  : process.env.REACT_APP_IMG_URL + slide.image
                                : "/assets/images/common alex jewellery.png"
                            }
                            imgClassName="category-image"
                          />
                          <div className="triangle-right"></div>
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div> */}

          {categories?.length === 0 ? (
            <p className="text-danger">
              No subcategory available for this category.
            </p>
          ) : (
            <>
              <div className="subcat_div">
                <div className="heading_holder">
                  <h4 className="heading_text">Shop By Category</h4>
                </div>
                <div variant="pills" className="flex-row p-0  mb-3">
                  <Swiper
                    className="mySwiper"
                    onSwiper={(swiper) => setSwiperInstance(swiper)}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    modules={[Pagination, Navigation]}
                    breakpoints={{
                      0: { slidesPerView: 2, spaceBetween: 10 },
                      486: { slidesPerView: 2.5, spaceBetween: 10 },
                      576: { slidesPerView: 3, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 10 },
                      992: { slidesPerView: 4, spaceBetween: 10 },
                      1200: { slidesPerView: 5, spaceBetween: 10 },
                      1400: { slidesPerView: 6, spaceBetween: 10 },
                      1800: { slidesPerView: 7, spaceBetween: 10 },
                    }}
                  >
                    {allsubcategory?.length > 0 &&
                      allsubcategory.map((slide, index) => (
                        <SwiperSlide key={index} className="product-slide">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={slide?.id}
                              className={
                                filters.subCategory.includes(slide.id)
                                  ? "activecategory"
                                  : ""
                              }
                              onClick={() => handleSubCategoryClick(slide?.id)}
                            >
                              <Category_Subcategory_Card
                                className="product-image second-swiper-product-image"
                                content={slide?.name}
                                image={
                                  slide?.image
                                    ? slide.image.startsWith("http")
                                      ? slide.image
                                      : process.env.REACT_APP_IMG_URL +
                                        slide.image
                                    : "/assets/images/common alex jewellery.png"
                                }
                                catDiscount={slide?.cat_discount}
                                imgClassName="category-image"
                              />
                              <div className="triangle-right"></div>
                            </Nav.Link>
                          </Nav.Item>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </>
          )}

          {productData?.data?.length === 0 ? (
            <p className="text-danger">
              No products available for this selection.
            </p>
          ) : (
            <div className="subcat_div">
              <div className="heading_holder">
                <h4 className="heading_text">Products</h4>
              </div>

              <div className="row">
                {productData?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={product?.image}
                        vdoSrc={product?.image}
                        productName={product?.name}
                        prodDiscount={product?.prod_discount}
                        productDesignId={product?.design_id}
                        priceText={product?.Product_Variants?.[0].price || 0}
                        mrp={product?.Product_Variants?.[0].mrp}
                        savingPrice={
                          parseFloat(product?.Product_Variants?.[0].mrp || 0) -
                          parseFloat(product?.Product_Variants?.[0].price || 0)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className="pagination pagination_holder mt-3 mb-3 d-flex justify-content-center align-items-center gap-2">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lsaquo;
            </button>

            {[currentPage].map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={page === currentPage ? "active" : ""}
              >
                {page}
              </button>
            ))}

            {totalPages > 3 && (
              <>
                <span>...</span>

                <button
                  onClick={() => handlePageChange(totalPages)}
                  className={currentPage === totalPages ? "active" : ""}
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &rsaquo;
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE FILTER OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        className="filter_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <FilterComponent
            filters={filters}
            updateFilter={updateFilter}
            categories={categories}
            subCategories={allsubcategory}
            colours={colours}
            sizes={sizes}
            polishes={polishes}
            earringStyles={earringStyles}
            necklaceStyles={necklaceStyles}
            occasions={occasions}
            designShapes={designShapes}
          />
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <div className="d-flex gap-3 justify-content-center">
            <div className="filter-btn">
              <Green_round_btn btnText="Clear" />
            </div>

            <div className="filter-btn">
              <Green_round_btn btnText="Apply" />
            </div>
          </div>
        </div>
      </Offcanvas>
    </section>
  );
}

export default Shop_By_Category;
